import React, { useState } from 'react'
import '../App.css'
import LoginRequest from './LoginRequest'
import AddWhitelist from './AddWhitelist'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'

const Whitelist = (props) => {
  props.stopListRefresh()

  //const [isLoggedIn, setIsLoggedIn] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  /* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsLoggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  const removeData = async (whitelistId) => {
    try {
      await axios.delete(`${SERVER_URI}/remove_from_whitelist/${whitelistId}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
    } catch (e) {
      console.log('Error in deleting the contact', e)
    }
    props.dispatch({
      type: 'DELETE_FROM_WHITELIST',
      data: { whitelistId: whitelistId },
    })
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddWhitelist dispatch={props.dispatch} handleClose={togglePopUp} />
      )}
      <h3>Luotetut numerot</h3>
      <span>
        <div className='discountRates'>
          <button id='lightBlue_button' onClick={togglePopUp}>
            Lisää luotettuihin
          </button>
          {props.whitelist === undefined ? (
            <LoginRequest />
          ) : props.whitelist.length === 0 ? (
            <h4>Ei numeroita</h4>
          ) : (
            <table id='contactTable'>
              <thead>
                <tr>
                  <th>Luotettu numero</th>
                </tr>
              </thead>
              <tbody>
                {props.whitelist.map((whitelist) => (
                  <tr key={whitelist.id} id={whitelist.id}>
                    <td>{whitelist.phoneNumber}</td>
                    <td className='operation'>
                      <button onClick={() => removeData(whitelist.id)}>
                        Poista
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </span>
    </div>
  )
}

export default Whitelist
